import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { Row } from 'react-data-grid';
import clsx from 'clsx';

export default function DraggableRowRenderer({
  rowIdx,
  isRowSelected,
  className,
  selectedIndexes,
  onRowReorder,
  ...props
}) {
  const [{ isDragging }, drag] = useDrag({
    type: 'ROW_DRAG',
    item: {
      indices: selectedIndexes.includes(rowIdx) ? selectedIndexes : [rowIdx],
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [{ isOver }, drop] = useDrop({
    accept: 'ROW_DRAG',
    drop(draggedItem) {
      if (!selectedIndexes.includes(rowIdx)) {
        onRowReorder(draggedItem.indices, rowIdx);
        draggedItem.indices = selectedIndexes.map(
          (i) => rowIdx + i - draggedItem.indices[0],
        );
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  className = clsx(className, {
    [{ opacity: 0.5 }]: isDragging,
    [{ backgroundColor: '#ececec' }]: isOver,
  });

  return (
    <Row
      ref={(ref) => {
        if (ref) {
          drag(ref.firstElementChild);
        }
        drop(ref);
      }}
      rowIdx={rowIdx}
      isRowSelected={isRowSelected}
      className={className}
      {...props}
    />
  );
}
